import React from 'react';
import '../../App.css';

function About() {
    return (
        <>
        <section className='bg-[#FAF4FD]'>
            <div className='container pt-5 pb-12'>
                <div className='flex flex-col md:flex-row relative container ml-0  md:ml-[34px]'>
                    <div className=''>
                    <p className='text-[#214B32] font-medium text-base mt-6 mb-6 md:mb-10 uppercase'>About Us</p>
                    <p className='section-head-main mt-6 md:mt-10 text-left mb-4'>We’re building the most affordable way to rent and live</p>
                    
                    <p className='mb-3'>We've personally experienced the challenges of house hunting, and we recognize the significant relief that comes from having access to affordable rental options.</p>
                    <p className='mb-3'>Bubble was created with the aim of enhancing affordability in the rental and living experience. Leveraging the current housing supply, we aim to create budget-friendly living spaces tailored to our thriving younger population.</p>
                    <p className='mb-3'>We also aim to offer renters services that save them time and effort. With our interactive Home App, our community has the advantage of awesome deals and offers on food delivery, laundry, groceries all from the comfort of your mobile device</p>

                        
                        
                    </div>
                    <div className='flex md:justify-between w-full phone:hidden'>
                        <img src='/images/bed.png' className='mt-[165px] ml-16'/>
                    </div>
                    {/* <img src='/images/newHomePic.png' className=''/> */}
                </div>
            </div>
        </section>
        <div className='mt-[120px] container bg-white flex flex-col gap-20'>
            <section className='mb-10'>
                <p className='text-center section-head-main md:w-[683px] md:mx-auto mb-12'>What we provide</p>
                <div className='phone:flex-col md:columns-3 phone:flex phone:gap-12'>
                    <div className='flex flex-col md:w-[408px] gap-8'>
                        <img src='/images/affordability.png'/>
                        <div className='bottom-0 bg-white pb-0'>
                            <p className='text-[#0B1911] font-bold text-lg text-[21px]'>Affordability</p>
                            <p className='text-[#214B32] font-normal text-lg'>We believe that everyone deserves a place they can call home, regardless of their financial circumstances. Our commitment to providing affordable rental homes goes beyond bricks and mortar – it's about creating opportunities for individuals and families to thrive.</p>
                        </div>
                    </div>
                    <div className='flex flex-col md:w-[408px] gap-8'>
                        <img src='/images/community.png'/>
                        <div className='bottom-0 bg-white pb-0'>
                            <p className='text-[#0B1911] font-bold text-lg text-[21px]'>Community</p>
                            <p className='text-[#214B32] font-normal text-lg'>From thoughtfully designed communal spaces that encourage conversations to organized events that bring neighbors together, we're dedicated to nurturing an environment where everyone feels valued and connected.</p>
                        </div>
                    </div>
                    <div className='flex flex-col md:w-[408px] gap-8'>
                        <img src='/images/convinience.png'/>
                        <div className='bottom-0 bg-white pb-0'>
                            <p className='text-[#0B1911] font-bold text-lg text-[21px]'>Convenience</p>
                            <p className='text-[#214B32] font-normal text-lg'>Imagine a home where everything you need is within reach. From strategically located properties that offer easy access to major thoroughfares and public transportation to thoughtfully designed interiors that streamline daily routines, we're all about simplifying your life.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className='relative flex w-full justify-center items-center'>
                    <img src='/images/nexthomebg.png' className='phone:h-[479px]'/>
                    <div className='absolute px-4 w-[360px] md:w-[846px] mx-auto phone:mx-30px] bg-white py-14 text-center items-center rounded-lg flex flex-col'>
                        <p className='text-center section-head-main pb-4'>Ready to find your next home?</p>
                        <p className='text-xl font-normal pb-10'>We have homes specially designed for you across your city!</p>
                        <a className='block w-[280px] rounded-xl bg-[#64E296] text-[#214B32] text-center py-4 text-base mt-3' href='/rent-a-home'>Find my home</a>
                    </div>

                </div>
            </section>
            
        </div>
    </>
    )
}

export default About;

